import { render } from "./learnerCentral.vue?vue&type=template&id=24b2cfe4&scoped=true"
import script from "./learnerCentral.vue?vue&type=script&lang=js"
export * from "./learnerCentral.vue?vue&type=script&lang=js"

import "./learnerCentral.vue?vue&type=style&index=0&id=24b2cfe4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b2cfe4"]])

export default __exports__